$bog_max_app $mol_book2
	bot_prod \https://cmyser-ru-max.91.188.212.151.ip.giper.dev/
	attr *
		^
		bog_max_platform <= platform \web
	plugins /
		<= Theme $bog_theme_auto
			theme_light \$mol_theme_calm_light
			theme_dark \$mol_theme_calm_dark
			themes /
				\$mol_theme_calm_light
				\$mol_theme_calm_dark
	pages /
	placeholders /
	Main $mol_page
		title <= main_title \
		Logo <= Max_logo $mol_image
			uri \bog/max/assets/max.svg
			title \MAX
		tools /
			<= Sync $giper_baza_status
			<= Theme_toggle $bog_theme_toggle
				theme_auto <= Theme
		body <= main_body /
		foot /
			<= Nav $bog_max_nav
				section <= section \tickets
				staff <= staff false
				admin <= admin false
	Wait $mol_paragraph
		title @ \Подключаемся к управляющей компании…
	Fail $mol_paragraph
		title <= fail \
	Reset $mol_button_minor
		title @ \Сбросить локальные данные
		click? <=> reset? null
	New_link $mol_link
		arg *
			screen \new
			ticket null
		sub /
			<= New_button $mol_button_major
				title @ \Новая заявка
	House_title $mol_paragraph
		title <= house_title \
	House_missing $mol_view
		sub /
			<= House_missing_icon $mol_icon_camera
			<= House_missing_text $mol_paragraph
				title @ \Дом не подключён. Отсканируйте камерой QR-код на подъезде или откройте ссылку от вашей УК, и дом подставится сам.
	Empty $mol_paragraph
		title @ \Заявок пока нет. Нажмите «Новая заявка», чтобы сообщить о проблеме в доме.
	Rows $mol_list
		rows <= rows /
			<= Row* $mol_link
				arg *
					ticket <= row_link* \
					screen null
				sub /
					<= Row_title* $mol_paragraph
						title <= row_title* \
					<= Row_status* $mol_paragraph
						title <= row_status* \
	House_pick $mol_select
		options <= house_options /string
		dictionary <= house_dictionary *
		value? <=> house? \
	House_tabs $mol_switch
		value? <=> house_tab? \tickets
		options *
			tickets @ \Заявки
			news @ \Новости
	Search $mol_search
		query? <=> query? \
		hint @ \Поиск по заявкам дома
	House_empty $mol_paragraph
		title @ \По этому дому заявок ещё нет.
	House_rows $mol_list
		rows <= house_rows /
	News_empty $mol_paragraph
		title @ \Новостей по этому дому пока нет.
	News $mol_list
		rows <= news_rows /
			<= Post* $mol_view
				sub /
					<= Post_title* $mol_paragraph
						title <= news_title* \
					<= Post_when* $mol_paragraph
						title <= news_when* \
					<= Post_text* $mol_paragraph
						title <= news_text* \
	Account_head $mol_view
		sub <= account_head /
	Account_photo $mol_image
		uri <= account_photo \
		title <= account_name \
	Account_avatar $mol_avatar
		id <= account_id \
	Account_titles $mol_view
		sub <= account_titles /
	Account_name $mol_paragraph
		title <= account_name \
	Account_username $mol_paragraph
		title <= account_username \
	Account_id $mol_labeler
		title @ \ID в MAX
		content / <= account_id \
	Account_house $mol_form_field
		name @ \Мой дом
		control <= House $mol_select
			options <= house_options /string
			dictionary <= house_dictionary *
			value? <=> house? \
	Account_count $mol_labeler
		title @ \Заявок подано
		content / <= account_count \
	Account_note $mol_paragraph
		title @ \Дом подставляется в новые заявки. Ссылка или QR-код с кодом дома выбирает его сам.
	Account_role $mol_labeler
		title @ \Роль
		content / <= account_role \
	Account_code $mol_labeler
		title @ \Код сотрудника
		content / <= account_code \
	Account_code_note $mol_paragraph
		title @ \Сообщите код диспетчеру УК, и он откроет вам раздел диспетчера.
	Account_demo $mol_paragraph
		title @ \Демо: дома, категории и нормативы смоделированы по ПП 416, 354, 170, ГОСТ 50597 и 59-ФЗ. Организации подключены через API бота, реальных систем УК нет.
	Admin_title $mol_paragraph
		title @ \Последние открытые заявки. Статус меняется здесь или через API организации.
	All_link $mol_link
		arg *
			screen \all
			ticket null
		sub /
			<= All_button $mol_button_major
				title <= all_title \
	House_form $mol_form
		submit_allowed => house_allowed
		form_fields /
			<= House_address_field $mol_form_field
				name @ \Новый дом
				bids <= house_address_bids /string
				control <= House_address $mol_string
					hint @ \Адрес: улица, дом, корпус
					value? <=> house_address_new? \
		buttons /
			<= House_submit $mol_button_major
				title @ \Добавить дом
				click? <=> house_add? null
	Houses_title $mol_paragraph
		title @ \Дома УК. Удаление убирает дом из списков, заявки по нему остаются.
	Admin_houses $mol_list
		rows <= admin_house_rows /
			<= Admin_house* $mol_view
				sub /
					<= Admin_house_info* $mol_view
						sub /
							<= Admin_house_address* $mol_paragraph
								title <= house_address* \
							<= Admin_house_code* $mol_paragraph
								title <= house_code* \
					<= House_remove* $mol_button_minor
						hint @ \Удалить дом
						sub /
							<= House_remove_icon* $mol_icon_delete
							<= House_remove_label* $mol_paragraph
								title <= house_remove_title* \
						click? <=> house_remove*? null
	Admin_empty $mol_paragraph
		title @ \Заявок пока нет.
	Admin_rows $mol_list
		rows <= admin_rows /
			<= Admin_row* $mol_view
				sub <= admin_row_sub* /
					<= Row*
					<= Admin_status* $mol_select
						options <= status_options /string
						dictionary <= status_dictionary *
						value? <=> admin_status*? \
					<= Admin_note* $mol_string
						hint @ \Причина, её увидит житель
						value? <=> admin_note*? \
					<= Admin_owner* $mol_select
						options <= owner_options /string
						dictionary <= owner_dictionary *
						value? <=> admin_owner*? \
					<= Admin_alarm* $mol_paragraph
						title <= admin_alarm* \
	Stats_link $mol_link
		arg *
			screen \stats
			ticket null
		sub /
			<= Stats_button $mol_button_major
				title @ \Статистика по домам
	Stats $mol_page
		title @ \Статистика
		tools /
			<= Close_stats $mol_link
				arg *
					screen null
				sub /
					<= Close_stats_icon $mol_icon_close
		body /
			<= Stats_period $mol_switch
				value? <=> stats_period? \30
				options *
					7 @ \7 дней
					30 @ \30 дней
					90 @ \90 дней
					all @ \Всё время
			<= Stats_house_pick $mol_select
				options <= stats_house_options /string
				dictionary <= stats_house_dictionary *
				value? <=> stats_house? \
			<= Stats_summary $mol_view
				sub <= summary_rows /
			<= Stats_owners_title $mol_paragraph
				title @ \По ответственным
			<= Stats_owners $mol_list
				rows <= owner_stat_rows /
			<= Stats_houses_title $mol_paragraph
				title @ \По домам
			<= Stats_houses $mol_list
				rows <= stats_rows /
	Summary* $mol_view
		sub /
			<= Summary_value* $mol_paragraph
				title <= summary_value* \
			<= Summary_label* $mol_paragraph
				title <= summary_label* \
	Owner_stat* $mol_view
		sub /
			<= Owner_stat_name* $mol_paragraph
				title <= owner_stat_name* \
			<= Owner_stat_line* $mol_paragraph
				title <= owner_stat_line* \
	Stat* $mol_view
		sub /
			<= Stat_house* $mol_paragraph
				title <= stat_house* \
			<= Stat_line* $mol_paragraph
				title <= stat_line* \
	Orgs_title $mol_paragraph
		title @ \Интеграции организаций
	Orgs $mol_list
		rows <= org_rows /
			<= Org* $mol_view
				sub /
					<= Org_name* $mol_paragraph
						title <= org_name* \
					<= Org_state* $mol_paragraph
						title <= org_state* \
	Qr_title $mol_paragraph
		title @ \QR-код дома. Наклейте у подъезда: житель откроет бота сразу с этим домом.
	Qr_house $mol_select
		options <= my_houses /string
		dictionary <= house_dictionary *
		value? <=> qr_house? \
	Qr $bog_qr
		uri <= qr_uri \
	Qr_link $mol_paragraph
		title <= qr_uri
	Qr_print $mol_button_major
		title @ \Распечатать QR
		click? <=> qr_print? null
	Staff_title $mol_paragraph
		title @ \Сотрудники. Пришлите ссылку-приглашение админа или введите код сотрудника из его профиля и выберите роль.
	Staff_invite $mol_paragraph
		title <= staff_link \
	Staff_qr $bog_qr
		uri <= staff_link
	Staff_form $mol_view
		sub /
			<= Staff_code $mol_string
				hint @ \Код сотрудника
				value? <=> staff_code? \
			<= Staff_role_label $mol_paragraph
				title @ \Роль сотрудника:
			<= Staff_role $mol_switch
				value? <=> staff_role? \dispatcher
				options *
					dispatcher @ \Диспетчер
					admin @ \Админ
			<= Staff_houses_label $mol_paragraph
				title @ \Дома диспетчера, добавьте плюсом:
			<= Staff_houses $mol_select_list
				options <= house_options /string
				dictionary <= house_dictionary *
				value? <=> staff_houses? /string
				pick_hint @ \Дома диспетчера
			<= Staff_add $mol_button_major
				title @ \Добавить сотрудника
				click? <=> staff_add? null
	Post_form $mol_form
		submit_allowed => post_allowed
		form_fields /
			<= Post_title_field $mol_form_field
				name @ \Новость или отключение
				bids <= post_title_bids /string
				control <= Post_title_input $mol_string
					hint @ \Заголовок
					value? <=> post_title? \
			<= Post_text_field $mol_form_field
				name @ \Текст
				control <= Post_text_input $mol_string
					hint @ \Что, когда, что делать жителям
					value? <=> post_text? \
			<= Post_kind_field $mol_form_field
				name @ \Тип
				control <= Post_kind $mol_select
					options /
						\news
						\outage
					dictionary *
						news @ \Новость
						outage @ \Отключение или ремонт
					value? <=> post_kind? \news
			<= Post_house_field $mol_form_field
				name @ \Дом
				control <= Post_house $mol_select
					options <= my_houses /string
					dictionary <= house_dictionary *
					value? <=> post_house? \
		buttons /
			<= Post_submit $mol_button_major
				title @ \Опубликовать
				click? <=> post_add? null
	New $mol_page
		title @ \Новая заявка
		tools /
			<= Close_new $mol_link
				arg *
					screen null
				sub /
					<= Close_new_icon $mol_icon_close
		body <= new_body /
	House_line $mol_labeler
		title @ \Дом
		content / <= house_address \
	Form $mol_form
		submit_allowed => submit_allowed
		body <= new_fields /
		form_fields /
			<= House_field $mol_form_field
				name @ \Дом
				control <= House_new $mol_select
					options <= house_options /string
					dictionary <= house_dictionary *
					value? <=> house? \
			<= Scope_field $mol_form_field
				name @ \Где проблема
				control <= Scope $bog_max_pick
					options <= scope_options /string
					dictionary <= scope_dictionary *
					value? <=> scope? \house
					custom? <=> scope_custom? \
			<= Category_field $mol_form_field
				name @ \Что случилось
				attr *
					^
					bog_max_required \true
				bids <= category_bids /string
				control <= Category $bog_max_pick
					options <= category_options /string
					dictionary <= category_dictionary *
					value? <=> category? \
					custom? <=> category_custom? \
			<= Entrance_field $mol_form_field
				name @ \Подъезд
				control <= Entrance $mol_string
					hint @ \Номер подъезда, если важно
					value? <=> entrance? \
			<= Place_field $mol_form_field
				name @ \Где
				attr *
					^
					bog_max_required \true
				bids <= place_bids /string
				control <= Place $mol_string
					hint <= place_hint \
					value? <=> place? \
			<= Text_field $mol_form_field
				name @ \Подробности
				control <= Text $mol_string
					hint @ \Что именно не так
					value? <=> text? \
			<= Photo_field $mol_form_field
				name @ \Фото и видео
				control <= Photo_box $mol_view
					sub /
						<= Photo_row $mol_view
							sub /
								<= Photo_pick $mol_button_open
									files? <=> photo_picked? /File
									accept \image/*,video/*,.mp4,.mov,.m4v,.3gp,.webm,.mkv,.avi,.heic,.heif
									multiple true
									hint @ \Приложить фото или видео
								<= Photo_name $mol_paragraph
									title <= photo_pick_label \
						<= Photo_previews $mol_view
							sub <= photo_previews /
		buttons /
			<= Submit $mol_button_major
				title @ \Отправить заявку
				click? <=> submit? null
			<= Consent $mol_paragraph
				title @ \Отправляя заявку, вы соглашаетесь, что имя, ID в MAX, текст и фото заявки увидят УК и ответственная организация.
	Chat_item* $mol_view
		sub <= chat_item_sub* /
			<= Chat_open* $mol_link
				uri <= chat_url* \
				target \_blank
				sub /
					<= Chat_thumb* $mol_image
						uri <= chat_url* \
						loading \eager
			<= Chat_video* $mol_view
				dom_name \video
				attr *
					src <= chat_url* \
					controls \true
					playsinline \true
			<= Chat_drop* $mol_button_minor
				hint @ \Убрать
				sub /
					<= Chat_drop_icon* $mol_icon_close
				click? <=> chat_drop*? null
	Photo_item* $mol_view
		sub <= photo_item_sub* /
			<= Photo_open* $mol_link
				uri <= photo_url* \
				target \_blank
				sub /
					<= Photo_thumb* $mol_image
						uri <= photo_url* \
						loading \eager
			<= Photo_video* $mol_view
				dom_name \video
				attr *
					src <= photo_url* \
					controls \true
					playsinline \true
			<= Photo_drop* $mol_button_minor
				hint @ \Убрать
				sub /
					<= Photo_drop_icon* $mol_icon_close
				click? <=> photo_drop*? null
	Similar_title $mol_paragraph
		title @ \Похожая заявка уже есть. Поддержите её, так она поднимется выше:
	Similar $mol_list
		rows <= similar_rows /
	All $mol_page
		title @ \Все заявки
		tools /
			<= Close_all $mol_link
				arg *
					screen null
				sub /
					<= Close_all_icon $mol_icon_close
		body /
			<= All_search $mol_search
				query? <=> all_query? \
				hint @ \Поиск по номеру, категории, дому, месту
			<= All_status $mol_select
				options <= all_status_options /string
				dictionary <= all_status_dictionary *
				value? <=> all_status? \
			<= All_rows $mol_list
				rows <= all_rows /
	Ticket $mol_page
		title <= ticket_title \
		tools /
			<= Close_ticket $mol_link
				arg *
					ticket null
				sub /
					<= Close_ticket_icon $mol_icon_close
		body <= ticket_body /
	Ticket_status $mol_paragraph
		title <= ticket_status \
	Ticket_uploading $mol_paragraph
		title @ \Фото и видео отправляются, не закрывайте приложение несколько секунд.
	Ticket_note $mol_paragraph
		title <= ticket_note \
	Ticket_media $mol_view
		sub <= ticket_media /
			<= Ticket_item* $mol_view
				sub <= ticket_item_sub* /
			<= Ticket_image* $mol_link
				uri <= ticket_media_url* \
				target \_blank
				sub /
					<= Ticket_image_pic* $mol_image
						uri <= ticket_media_url* \
						loading \eager
			<= Ticket_video* $mol_view
				dom_name \video
				attr *
					src <= ticket_media_url* \
					controls \true
					playsinline \true
	Ticket_category $mol_labeler
		title @ \Категория
		content / <= ticket_category \
	Ticket_house $mol_labeler
		title @ \Дом
		content / <= ticket_house \
	Ticket_place $mol_labeler
		title @ \Где
		content / <= ticket_place \
	Ticket_text $mol_labeler
		title @ \Подробности
		content / <= ticket_text \
	Ticket_owner $mol_labeler
		title @ \Ответственный
		content / <= ticket_owner \
	Ticket_alarm $mol_view
		sub /
			<= Ticket_alarm_text $mol_paragraph
				title <= ticket_alarm_text \
			<= Alarm $mol_button_minor
				title @ \Эскалировать
				click? <=> alarm? null
				enabled <= alarm_allowed true
	Ticket_react $mol_labeler
		title @ \Реакция по нормативу
		content / <= ticket_react \
	Ticket_fix $mol_labeler
		title @ \Устранение по нормативу
		content / <= ticket_fix \
	Ticket_basis $mol_labeler
		title @ \Основание
		content / <= ticket_basis \
	Voices $mol_view
		sub /
			<= Voices_count $mol_paragraph
				title <= voices_text \
			<= Voice $mol_button_major
				title @ \Тоже беспокоит
				click? <=> voice? null
				enabled <= voice_allowed true
	Log $mol_list
		rows <= log_rows /
			<= Log_row* $mol_paragraph
				title <= log_row* \
